/**
 * Adresy portalu 33rp składane przez ekran — z językiem, w którym człowiek
 * czyta ten ekran (`lang=pl|en`, kontrakt z ADR 0001 w `erp/33rp`). Sam adres
 * przychodzi z serwera (`GET /auth/entry`), bo wynika ze SKONFIGUROWANEGO
 * issuera, a nie z literału — instancja testowa nie odsyła na produkcję.
 */
export function withLang(url: string, lang: string): string {
  const target = new URL(url)
  target.searchParams.set('lang', lang === 'en' ? 'en' : 'pl')
  return target.toString()
}
